export const OPTION_TYPE = [
  {
    label: 'reportBusNotCheckIn.filter.checkIn',
    value: 'Y',
  },
  {
    label: 'reportBusNotCheckIn.filter.notCheckIn',
    value: 'N',
  },
  {
    label: 'reportBusNotCheckIn.filter.all',
    value: 'ALL',
  },
]
